import React, { useEffect } from "react";
import { Container, Typography, Box, Button, Grid } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "../../index"
import {
  Info as InfoIcon,
  Description as DescriptionIcon,
} from "@mui/icons-material";
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import GroupsIcon from '@mui/icons-material/Groups';
import YouTubeIcon from '@mui/icons-material/YouTube';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';

import BannerTransparencia from "../../assets/img/bannerTransparencia.png";
import UltimasNoticias from "./components/ultimasNoticias";
import UltimasPublicacoes from "./components/ultimasPublicacoes";
import Swal from "sweetalert2"; // Adicione essa linha no topo do arquivo
import TVCamara from "./components/tvCamara";
import SocialMedia from "./components/socialMidia";



const HomePage = () => {
  useEffect(() => {
    // Verifica se o pop-up já foi exibido anteriormente e se já passou um dia desde então
    const popupExibido = localStorage.getItem("popupExibido");
    const ultimaExibicao = localStorage.getItem("ultimaExibicao");
  
    if (!popupExibido || (ultimaExibicao && new Date() - new Date(ultimaExibicao) > 1 * 4 * 60 * 60 * 1000)) {
      // Se o pop-up ainda não foi exibido ou se já passou um dia desde a última exibição, exibe-o
      Swal.fire({
        title: "Bem-vindo ao site da Câmara Municipal de Serra Caiada",
        html: "Clique no botão abaixo para realizar pesquisa de satisfação.",
        imageUrl: "https://www.paraibunaprev.com.br/wp-content/uploads/2022/04/Pesquisa-de-satisfacao-8-770x619.png",
        imageHeight: 180, // Ajuste a altura da imagem
        showCancelButton: true,
        confirmButtonText: "Visitar link",
        cancelButtonText: "Fechar",
        width: '400px',  // Diminuindo a largura do pop-up
        padding: '10px',  // Ajustando o preenchimento interno
        customClass: {
          popup: 'custom-popup',  // Usando uma classe customizada para mais ajustes
        }
      }).then((result) => {
        if (result.isConfirmed) {
          // Se o botão "Visitar link" for clicado, redireciona para o link desejado
          window.open("https://docs.google.com/forms/d/e/1FAIpQLSdVy6z3q_r68ozOycw4BpUYWYZFGILBrx3svdZNEMwN7bBw6A/formResponse", "_blank");
        }
        // Marca o pop-up como exibido e armazena a data da última exibição
        localStorage.setItem("popupExibido", "true");
        localStorage.setItem("ultimaExibicao", new Date());
      });
    }
  }, []);

  
  
  const theme = useTheme();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const quickAccessButtons = [
    {
      label: "E-SIC",
      icon: <InfoIcon />,
      description: "Serviços de Informações ao Cidadão",
      link: "https://esic-cmserracaiada.prosipe.com/index/",
    },
    {
      label: "TRANSPARÊNCIA",
      icon: <DescriptionIcon />,
      description: "PORTAL DA TRANSPARÊNCIA",
      link: "https://cmserracaiadarn.transparencia.topsolutionsrn.com.br/",
    },
    {
      label: "Portal do Servidor",
      icon: <GroupsIcon />,
      description: "Área destinada aos servidores se informarem de seus dados cadastrados junto a Câmara",
      link: "/",
    },
    {
      label: "Ouvidoria",
      icon: <QuestionAnswerIcon />,
      description: "Informações, denúncias sobre o que ocorre no múnicipio do Serra Caiada, acesse aqui!",
      link: "/faleconosco",
    },
    {
      label: "TV Camara",
      icon: <YouTubeIcon />,
      description: "Veja todas as sessões no nosso canal do YouTube",
      link: "https://www.youtube.com/channel/UCqb5teVCtj0MjyV7Z3_2UqQ",
    },

    {
      label: "INSTITUCIONAL",
      icon: <CorporateFareIcon />,
      description: "Informações sobre o institucional da Camara ",
      link: "/institucional",
    },
  ];

  return (

    <Container
      maxWidth={false}
      disableGutters
      sx={{
        width: { xs: "95%", md: "70%" },
        display: "flex",
        gap: "3em",
        flexDirection: "column",
      }}
    >
      
      <UltimasNoticias />

      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          alignContent: "center",
        }}
      >
        <Grid
          container
          spacing={2}
          justifyContent="center"
          flexDirection="row"
          width="100%"
        >
          {quickAccessButtons.map((button, index) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              key={index}
              display="flex"
              justifyContent="center"
              width="100%"
            >
              <Button
                sx={{
                  flexGrow: 1,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "150px",
                  width: "100%",
                  borderRadius: "10px",
                  textAlign: "center",
                  color: theme.palette.text.primary,
                  boxShadow: theme.shadows[2],
                  position: "relative",
                  overflow: "hidden",
                  padding: "20px",
                  backgroundColor: theme.palette.background.default,
                }}
                href={button.link}
              >
                {React.cloneElement(button.icon, {
                  style: {
                    fontSize: "40px",
                    color: theme.palette.primary.main,
                  },
                })}
                <Typography variant="h6" fontWeight="bold" mt={1}>
                  {button.label}
                </Typography>
                <Typography variant="body2" sx={{ textAlign: "center" }}>
                  {button.description}
                </Typography>
              </Button>
            </Grid>
          ))}
        </Grid>
      </Box>


      <UltimasPublicacoes />

      <TVCamara />
      
      <SocialMedia />

      <Box
        sx={{
          width: "100%",
          height: "30vh",
          position: "relative",
          borderRadius: "10px",
        }}
        
      >
        <Swiper
          modules={[Pagination, Navigation, Autoplay]}
          pagination={{ clickable: true }}
          navigation={true}
          autoplay={{ delay: 10000, disableOnInteraction: false }}
          loop={true}
          style={{ height: "100%" }}
        >
          {[BannerTransparencia, BannerTransparencia].map((banner, index) => (
            <SwiperSlide key={index}>
              <a href="https://radar.tce.mt.gov.br/extensions/radar-da-transparencia-publica/panel.html" target="_blank" rel="noopener noreferrer">
                <Box
                  sx={{
                    width: "100%",
                    height: "100%",
                    backgroundImage: `url(${banner})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    borderRadius: "10px",
                  }}
                />
              </a>
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>
    </Container>
  );
};

export default HomePage;
